/* Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. */
import { Component } from '@appCanvasCommon/component-system/Component';
import { ComponentInterface } from '@appCanvasCommon/interfaces/component.interface';
import { CanvasAngularLand } from '../../../../app-data/interfaces/canvas-angular-land';
import { AbstractApplication } from '@appCanvasCommon/core/AbstractApplication';
import { Container } from 'pixi.js-legacy';
import { LayerPaths } from '@appPlanApplication/LayerPaths';
/**
 * This export component hides the root promise period node when the lightbox is first created
 */
export class HidePromisePeriod extends Component implements ComponentInterface {
	/**
	 * Invoked once the lightbox is first created
	 * @param canvasAngularLand
	 * @param application
	 */
	public onExportPreviewStarted(
		canvasAngularLand: CanvasAngularLand,
		application: AbstractApplication
	): void {
		const backgroundPromisePeriod: Container | null = application.layerManager.getLayer(
			LayerPaths.BACKGROUND_VISUALS_PROMISE_PERIOD
		);
		if (backgroundPromisePeriod) {
			backgroundPromisePeriod.visible = false;
			backgroundPromisePeriod.renderable = false;
		}

		const timelinePromisePeriod: Container | null = application.layerManager.getLayer(
			LayerPaths.UI_TIMELINE_PROMISE_PERIOD
		);
		if (timelinePromisePeriod) {
			timelinePromisePeriod.visible = false;
			timelinePromisePeriod.renderable = false;
		}
	}
	/**
	 * Invoked once the export is finished. This turns the promise period back on
	 * @param canvasAngularLand
	 * @param application
	 */
	public onExportPreviewClosed(canvasAngularLand: CanvasAngularLand, application: AbstractApplication): void {
		const backgroundPromisePeriod: Container | null = application.layerManager.getLayer(
			LayerPaths.BACKGROUND_VISUALS_PROMISE_PERIOD
		);
		if (backgroundPromisePeriod) {
			backgroundPromisePeriod.visible = true;
			backgroundPromisePeriod.renderable = true;
		}

		const timelinePromisePeriod: Container | null = application.layerManager.getLayer(
			LayerPaths.UI_TIMELINE_PROMISE_PERIOD
		);
		if (timelinePromisePeriod) {
			timelinePromisePeriod.visible = true;
			timelinePromisePeriod.renderable = true;
		}
	}
}
